import React, { useState } from 'react';
import styles from './BrandForm.module.scss';
import Container from '../../../templates/Container';
import participantImage from '../../../../assets/img/participant.png';
import ReactInputMask from 'react-input-mask';
import classnames from '../../../../hooks/classnames';
import { sendBrandSupportRegister } from '../../../../redux/requests/sendBrandSupportRegister';
import validator from 'validator';
import normalizeUrl from 'normalize-url';
import useMobileDetect from 'use-mobile-detect-hook';
import BrandNot from './BrandNot';

const BrandForm = () => {
  const [organization, setOrganization] = useState('');
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [patronymic, setPatronymic] = useState('');
  const [product, setProduct] = useState('');
  const [description, setDescription] = useState('');
  const [website, setWebsite] = useState('');
  const [legalForm, setLegalForm] = useState('');
  const [inn, setInn] = useState('');
  const [territory, setTerritory] = useState('');
  const [phone, setPhone] = useState('');
  const [mail, setMail] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [creativeIndustries, setCreativeIndustries] = useState('');
  const [success, setSuccess] = useState(false);
  const [invalidMessage, setInvalidMessage] = useState('');

  const detectMobile = useMobileDetect();
  const isMobile = detectMobile.isMobile();

  const resetAll = () => {
    setOrganization('');
    setSurname('');
    setName('');
    setPatronymic('');
    setProduct('');
    setDescription('');
    setWebsite('');
    setLegalForm('');
    setInn('');
    setTerritory('');
    setPhone('');
    setMail('');
    setCreativeIndustries('');
    setInvalidMessage('');
  };

  const validate = (data) => {
    let valid = true;
    if (!data.organization) {
      document.getElementById('organization').classList.add('invalid');
      setInvalidMessage('Введите название организации');
      valid = false;
    }
    if (!data.surname) {
      document.getElementById('surname').classList.add('invalid');
      setInvalidMessage('Введите фамилию');
      valid = false;
    }
    if (!data.name) {
      document.getElementById('name').classList.add('invalid');
      setInvalidMessage('Введите имя');
      valid = false;
    }
    if (!data.inn) {
      document.getElementById('inn').classList.add('invalid');
      setInvalidMessage('Введите ИНН');
      valid = false;
    }
    if (!data.phone) {
      document.getElementById('phone').classList.add('invalid');
      setInvalidMessage('Введите номер телефона');
      valid = false;
    }
    if (!data.email) {
      document.getElementById('mail').classList.add('invalid');
      setInvalidMessage('Введите email');
      valid = false;
    }
    if (validator.isEmail(data.email) === false) {
      document.getElementById('mail').classList.add('invalid');
      setInvalidMessage('Введите корректный email');
      valid = false;
    }
    if (!data.product_name) {
      document.getElementById('product_name').classList.add('invalid');
      setInvalidMessage('Введите название продукта');
      valid = false;
    }
    if (!data.product_description) {
      document.getElementById('product_description').classList.add('invalid');
      setInvalidMessage('Введите описание продукта');
      valid = false;
    }
    if (!data.legal_form) {
      document.getElementById('legal_form').classList.add('invalid');
      setInvalidMessage('Введите форму юридического лица');
      valid = false;
    }
    if (!data.creative_industries) {
      document.getElementById('creative_industries').classList.add('invalid');
      setInvalidMessage('Выберите направление кр.индустрии');
      valid = false;
    }
    if (!data.product_production_area) {
      document.getElementById('product_production_area').classList.add('invalid');
      setInvalidMessage('Введите территорию производства');
      valid = false;
    }
    if (data.site && validator.isURL(data.site) === false) {
      document.getElementById('website').classList.add('invalid');
      setInvalidMessage('Введите сайт правильно');
      valid = false;
    }
    return valid;
  };

  const sendData = async () => {
    let data = {
      organization: organization,
      surname: surname,
      name: name,
      patronymic: patronymic,
      creative_industries: creativeIndustries,
      product_name: product,
      product_description: description,
      site: website && normalizeUrl(website),
      legal_form: legalForm,
      inn: inn,
      product_production_area: territory,
      phone: phone,
      email: mail,
    };
    if (validate(data)) {
      const res = await sendBrandSupportRegister(data, setDisabled);
      setDisabled(false);

      if (res?.id) {
        setSuccess(true);
        resetAll();
      }
    }
  };

  return (
    <section className={styles.section}>
      {success && (
        <div className={styles.modal}>
          <div className={styles.modal_content}>
            <p className={styles.successTitle}>
              Ваша заявка принята к&nbsp;рассмотрению.
              <br /> Ожидайте обратную связь.
            </p>
            <button onClick={() => setSuccess(false)} className={styles.closeButton}>
              закрыть х
            </button>
          </div>
        </div>
      )}
      <Container>
        <h2 className={styles.title}>
          <img src={participantImage} alt="" />
          <span>Стать участником</span>
        </h2>

        <div className={styles.form}>
          <div className={styles.top}>
            <p>Регистрация</p>
            {invalidMessage && !isMobile && <span className={styles.invalidMessage}>{invalidMessage}</span>}
            <button onClick={resetAll}>Очистить</button>
          </div>

          <ul className={styles.content}>
            <li className={styles.item} style={{ gridArea: '1/1/2/2' }}>
              <label>
                <span>Название организации *</span>
                <input
                  id="organization"
                  type="text"
                  value={organization}
                  onChange={(e) => setOrganization(e.target.value)}
                />
              </label>
            </li>
            <li className={styles.item} style={{ gridArea: '2/1/3/2' }}>
              <label>
                <span>Фамилия *</span>
                <input id="surname" type="text" value={surname} onChange={(e) => setSurname(e.target.value)} />
              </label>
            </li>
            <li className={styles.item} style={{ gridArea: '3/1/4/2' }}>
              <label>
                <span>Имя *</span>
                <input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} />
              </label>
            </li>
            <li className={styles.item} style={{ gridArea: '4/1/5/2' }}>
              <label>
                <span>Отчество</span>
                <input id="patronymic" type="text" value={patronymic} onChange={(e) => setPatronymic(e.target.value)} />
              </label>
            </li>
            <li className={styles.item} style={{ gridArea: '5/1/6/2' }}>
              <label>
                <span>Направление креативных индустрий *</span>
                <input
                  id="creative_industries"
                  type="text"
                  value={creativeIndustries}
                  onChange={(e) => setCreativeIndustries(e.target.value)}
                  placeholder="Мода, арт, музыка и т.д."
                />
              </label>
            </li>
            <li className={styles.item} style={{ gridArea: '6/1/7/2' }}>
              <label>
                <span>Название продукта *</span>
                <input id="product_name" type="text" value={product} onChange={(e) => setProduct(e.target.value)} />
              </label>
            </li>
            <li className={styles.item} style={{ gridArea: '7/1/9/2' }}>
              <label>
                <span>Описание продукта *</span>
                <textarea
                  id="product_description"
                  type="text"
                  rows={5}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </label>
            </li>
            <li className={styles.item}>
              <label>
                <span>Сайт/соцсети продукта (при наличии)</span>
                <input id="website" type="text" value={website} onChange={(e) => setWebsite(e.target.value)} />
              </label>
            </li>
            <li className={styles.item}>
              <label>
                <span>Юридическая форма *</span>
                <input
                  id="legal_form"
                  placeholder="ООО, ИП, самозанятый или другое"
                  type="text"
                  value={legalForm}
                  onChange={(e) => setLegalForm(e.target.value)}
                />
              </label>
            </li>
            <li className={styles.item}>
              <label>
                <span>ИНН *</span>
                <input id="inn" type="text" value={inn} onChange={(e) => setInn(e.target.value)} />
              </label>
            </li>
            <li className={styles.item} style={{ gridRow: 'span 2' }}>
              <label>
                <span>Территория производства продукта *</span>
                <textarea
                  id="product_production_area"
                  type="text"
                  rows={5}
                  value={territory}
                  onChange={(e) => setTerritory(e.target.value)}
                />
              </label>
            </li>
            <li className={styles.item}>
              <label>
                <span>Телефон *</span>
                <ReactInputMask
                  id="phone"
                  type="tel"
                  mask="+7\ 999 999-99-99"
                  maskchar="_"
                  required={true}
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
              </label>
            </li>
            <li className={styles.item}>
              <label>
                <span>E-mail *</span>
                <input id="mail" type="text" value={mail} onChange={(e) => setMail(e.target.value)} />
              </label>
            </li>
            {invalidMessage && isMobile && (
              <li>
                <span className={styles.invalidMessage}>{invalidMessage}</span>
              </li>
            )}
            <li className={classnames([styles.item, styles.item__button])}>
              <button onClick={() => sendData()}>Подтвердить</button>
            </li>
          </ul>
          <p className={styles.bottom}>* - Поля, обязательные для заполнения</p>
        </div>

        <BrandNot />
      </Container>
    </section>
  );
};

export default BrandForm;
